import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { StoreInformation } from '@/icons/store-information';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: (
        <CrumbTitle
          title="Basic Stores"
          id="manageStoreInformation.basicStore.crumb.basicStore"
          icon={StoreInformation}
        />
      ),
      title: <Translation id="storeManagement.basicStores.page.title" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
